var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"income-detail",on:{"click":function($event){return _vm.transClass($event)}}},[_c('DayDetail',{attrs:{"closePop":_vm.closePop}}),_c('WorkDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }